module.exports = __webpack_public_path__ + "static/media/MentorAmy.2e86dfe7.jpg";